export default __webpack_public_path__ + "static/heat-291feb1eeb3bd7e64e0f776e5ab4b50b.jpg";